var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPCard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#EEEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.47 30.75H22.47C20.05 30.75 18.72 29.42 18.72 27V13C18.72 10.58 20.05 9.25 22.47 9.25H26.47C28.89 9.25 30.22 10.58 30.22 13V27C30.22 29.42 28.88 30.75 26.47 30.75ZM22.47 10.75C20.89 10.75 20.22 11.42 20.22 13V27C20.22 28.58 20.89 29.25 22.47 29.25H26.47C28.05 29.25 28.72 28.58 28.72 27V13C28.72 11.42 28.05 10.75 26.47 10.75H22.47Z",
    fill: "#FF7D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.47 14.75H19.47C19.06 14.75 18.72 14.41 18.72 14C18.72 13.59 19.06 13.25 19.47 13.25H24.47C24.88 13.25 25.22 13.59 25.22 14C25.22 14.41 24.88 14.75 24.47 14.75Z",
    fill: "#FF7D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.47 26.75H19.47C19.06 26.75 18.72 26.41 18.72 26C18.72 25.59 19.06 25.25 19.47 25.25H23.47C23.88 25.25 24.22 25.59 24.22 26C24.22 26.41 23.88 26.75 23.47 26.75Z",
    fill: "#FF7D38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.47 22.75C24.46 22.75 24.46 22.75 24.47 22.75L19.46 22.7C19.05 22.7 18.71 22.36 18.72 21.94C18.72 21.53 19.06 21.2 19.47 21.2C19.47 21.2 19.47 21.2 19.48 21.2L24.48 21.25C24.89 21.25 25.23 21.59 25.22 22.01C25.21 22.42 24.88 22.75 24.47 22.75Z",
    fill: "#FF7D38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.47 18.75H19.47C19.06 18.75 18.72 18.41 18.72 18C18.72 17.59 19.06 17.25 19.47 17.25H22.47C22.88 17.25 23.22 17.59 23.22 18C23.22 18.41 22.88 18.75 22.47 18.75Z",
    fill: "#FF7D38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.49 30.72C12.58 30.72 11.72 30.16 11.13 29.18L10.31 27.82C10.01 27.32 9.78 26.5 9.78 25.92V12.95C9.78 10.91 11.44 9.25 13.48 9.25C15.52 9.25 17.18 10.91 17.18 12.95V25.91C17.18 26.49 16.95 27.31 16.65 27.81L15.83 29.17C15.26 30.16 14.4 30.72 13.49 30.72ZM13.49 10.75C12.28 10.75 11.29 11.74 11.29 12.95V25.91C11.29 26.22 11.44 26.77 11.6 27.04L12.42 28.4C12.73 28.92 13.12 29.21 13.49 29.21C13.86 29.21 14.25 28.91 14.56 28.4L15.38 27.04C15.54 26.77 15.69 26.22 15.69 25.91V12.95C15.69 11.74 14.7 10.75 13.49 10.75Z",
    fill: "#FF7D38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 15.75H10.53C10.12 15.75 9.78 15.41 9.78 15C9.78 14.59 10.12 14.25 10.53 14.25H16.44C16.85 14.25 17.19 14.59 17.19 15C17.19 15.41 16.85 15.75 16.44 15.75Z",
    fill: "#FF7D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPCard1);
export default __webpack_public_path__ + "static/media/p_card_1.170dce850e213486ae68d07c0a29973a.svg";
export { ForwardRef as ReactComponent };